export enum CancellationStepsEnum {
  Motivo = 1,
  Beneficiarios = 2,
  CartaCancelamento = 3,
  Termos = 4,
  Finalizacao = 5,
}